<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Localidades</h4>
    <hr />

    <DataTable
      :data="localidads"
      :columns="columnas"
      idField="idLocalidad"
      mensajeVacio="No hay localidades registradas."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="esAdmin"
      :mostrarEliminar="esAdmin"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idLocalidad)"
      @view="row => abrirEditar(row.idLocalidad)"
      @delete="row => deleteLocalidad(row.idLocalidad)"
    >
      <!-- Búsqueda por nombre en la barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoLocalidad.idLocalidad"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Localidad Superior -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Localidad Sup.</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-select"
                      v-model="datoLocalidad.idLocalidadSup"
                    >
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="loc in localidadSups"
                        :value="loc.idLocalidad"
                        :key="loc.idLocalidad"
                      >
                        {{ loc.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Código -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Código</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoLocalidad.codigo"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoLocalidad.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarLocalidad"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarLocalidad"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "LocalidadList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      localidads:     [],
      datoLocalidad:  {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      localidadSups:  [],
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Código", field: "codigo" },
        { label: "Nombre", field: "nombre" },
      ];
    },
    esAdmin() {
      const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
      return idPerfil === 1;
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
    this.fetchLocalidadSups();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwlocalidads")
        .then(r => { this.localidads = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar localidades:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwlocalidads/nombre/" + nombre)
        .then(r => { this.localidads = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar por nombre:", e));
    },

    async fetchLocalidadSups() {
      try {
        const r          = await api.get("/vwlocalidads");
        this.localidadSups = r.data;
      } catch (e) {
        console.error("Error fetching localidadSups:", e.response?.data || e.message);
      }
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoLocalidad,
        ["idLocalidadSup", "codigo", "nombre"],
        ["Localidad Superior", "Código", "Nombre"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarLocalidad() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/localidads", this.datoLocalidad);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Localidad creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarLocalidad() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/localidads", this.datoLocalidad);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Localidad actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteLocalidad(idLocalidad) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar localidad?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/localidads/" + idLocalidad);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoLocalidad = {};
      this.titulo        = "Crear Localidad";
      this.btnCrear      = true;
      this.btnEditar     = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idLocalidad) {
      this.modalWindow = true;
      this.titulo      = "Editar Localidad";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp         = await api.get("/vwlocalidads/" + idLocalidad);
        this.datoLocalidad = resp.data;
      } catch (e) {
        console.error("Error al cargar localidad:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idLocalidad) {
      if (idLocalidad != null) this.$router.push("/localidadmd/" + idLocalidad);
    },
  },
};
</script>